export default "__VITE_ASSET__C5DaYZ_u__"